import { useQuery } from "@apollo/client";
import { type OrganizationQuery, type OrganizationQueryVariables, getSelectedOrganization } from "../api/query";
// Alias-shim types kept intentionally while still-migrating camkit features (apps,
// groups, lenses, lens-source, connections) consume the output of this hook and
// expect the proto-style types. Removed when those features migrate.
import { type Permissions, type AuthorizedOperation } from "../../gql-generated";

export function useSelectedOrganization() {
    const { data, loading } = useQuery<OrganizationQuery, OrganizationQueryVariables>(getSelectedOrganization, {
        variables: {
            ghostMode: false,
        },
        fetchPolicy: "cache-only",
    });
    const permissions = data?.selectedOrganization?.permissions as unknown as Permissions;
    const orgAuthorizedOperations =
        (data?.selectedOrganization?.orgAuthorizedOperations as unknown as ReadonlyArray<AuthorizedOperation>) ??
        undefined;
    const accountIds = data?.selectedOrganization?.accountIds;
    const hasAppManagementPermissions = data?.selectedOrganization?.appsManagementEnabled;

    return {
        selectedOrganizationId: data?.selectedOrganization?.id,
        isNotSelected: data?.selectedOrganization?.id == null,
        hasAppManagementPermissions,
        permissions,
        orgAuthorizedOperations,
        accountIds,
        loading,
    };
}
